import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-2 sm:gap-3 ${className}`} data-id="element-287" data-mp="8t38tvsza2vl">
      <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/29840d0f-1015-4f19-b93f-876eb40e60ea/author-mark.png" alt="" className="h-8 w-8 shrink-0 object-contain sm:h-9 sm:w-9" width={36} height={36} decoding="async" data-id="element-288" data-mp="8v65uzsjsw9t" />
      {/* Visible wordmark from 360px up; sr-only keeps the name when it collapses */}
      <span className="sr-only" data-id="element-289" data-mp="rqw9erg4q0pt">Author Leverage</span>
      <span className="hidden whitespace-nowrap font-serif text-xl font-semibold tracking-tight text-navy min-[360px]:inline sm:text-2xl" aria-hidden="true" data-id="element-290" data-mp="rpl4upev0oxn">
        Author Leverage
      </span>
    </div>;
}